import { SavedTripDisplayModel } from '../../core/services/trips.service';
import { ITripPreference } from '../../core/types/interfaces/trip-elements.interface';

const defaultPreferences = {
  smallTowns: {
    name: 'Small Towns',
    icon: 'small_towns',
    value: 5,
    ref: 'smallTowns',
  },
  culture: {
    name: 'Culture',
    icon: 'culture',
    value: 5,
    ref: 'culture',
  },
  food: {
    name: 'Great Food',
    icon: 'food',
    value: 5,
    ref: 'food',
  },
  nature: {
    name: 'Nature',
    icon: 'nature',
    value: 5,
    ref: 'nature',
  },
  historic: {
    name: 'Historic Places',
    icon: 'historic',
    value: 5,
    ref: 'historic',
  },
  beaches: {
    name: 'Beaches',
    icon: 'beaches',
    value: 5,
    ref: 'beaches',
  },
  night: {
    name: 'Night Life',
    icon: 'night_life',
    value: 5,
    ref: 'night',
  },
  active: {
    name: 'Active',
    icon: 'active',
    value: 5,
    ref: 'active',
  },
};

const defaultPlannerConfig: {
  type: 'classic' | 'popular' | 'ai-optimizer';
  name: string;
  description: string;
} = {
  type: 'classic',
  name: '',
  description: '',
};

let selected: any;

export class Trip {
  public name: string = '';
  public blogUrl: string = '';
  public savesId: string = null;
  public isSpecifyDates: boolean = false;
  public isOptimizedMode: boolean = true;
  public startingCountry: string = null;
  public startingLocationId: string = null;
  public startingLabel: string = '';
  public endingCountry: string = null;
  public endingLocationId: string = null;
  public endingLabel: string = '';
  public rooms: {
    adults: number;
    ages: number[];
    children: number;
    rooms: number;
  } = { adults: 2, ages: [], children: 0, rooms: 1 };
  public route: any[] = [];
  public tripStartDate: string | Date = '';
  public tripEndDate: string | Date = '';
  public numDays: number;
  public scores: Record<string, ITripPreference> = defaultPreferences;
  public currency: any;
  public plannerInfo = defaultPlannerConfig;
  public includes: { id: number; name: string; days: number }[] = [];
  public excludes: { id: number; name: string }[] = [];
  public isPlanningTripLocation: boolean = true;
  public cityInfo: {
    id: number;
    url: string;
    label: string;
    countryId: number;
  } | null = null;

  public constructor(props?: Partial<Omit<Trip, 'constructor'>>) {
    if (props) {
      for (const key in props) {
        if (Object.prototype.hasOwnProperty.call(props, key)) {
          this[key] = props[key];
        }
      }
    }
  }

  public static CreateTripBasedOnSavedTripModel(
    savedTrip: SavedTripDisplayModel,
  ): Trip {
    return new Trip({
      isOptimizedMode: false,
      name: savedTrip.name,
      startingLabel: savedTrip.route[0].name,
      startingCountry: savedTrip.route[0].countryId,
      startingLocationId: savedTrip.route[0].id,
      endingLabel: savedTrip.route[savedTrip.route.length - 1].name,
      endingCountry: savedTrip.route[savedTrip.route.length - 1].countryId,
      endingLocationId: savedTrip.route[savedTrip.route.length - 1].id,
      tripStartDate: savedTrip.date_start,
      tripEndDate: savedTrip.date_end,
      numDays: +savedTrip.duration,
      route: savedTrip.route,
      isSpecifyDates: !isNaN(new Date(savedTrip.date_end) as never),
    });
  }

  public toString(): string {
    return JSON.stringify(this);
  }

  public updateTrip(props: Partial<Omit<Trip, 'constructor'>>): Trip {
    return new Trip({ ...this, ...props });
  }

  public destroyStartInLocation(): void {
    selected = this.getStoredProps();
    this.startingLabel = this.startingLocationId = this.startingCountry = '';
    this.destroyEndInLocation();
  }

  public destroyEndInLocation(): void {
    this.endingLocationId = this.endingLabel = this.endingCountry = '';
  }

  public restoreLocations(): Trip {
    return this.updateTrip(selected);
  }

  private getStoredProps(): any {
    return {
      startingLabel: this.startingLabel,
      startingLocationId: this.startingLocationId,
      startingCountry: this.endingCountry,
      endingLocationId: this.endingLocationId,
      endingLabel: this.endingLabel,
      endingCountry: this.endingCountry,
    };
  }
}
